import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=1889ea26&scoped=true&"
import script from "./Panel.vue?vue&type=script&lang=js&"
export * from "./Panel.vue?vue&type=script&lang=js&"
import style0 from "./Panel.vue?vue&type=style&index=0&id=1889ea26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889ea26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1889ea26')) {
      api.createRecord('1889ea26', component.options)
    } else {
      api.reload('1889ea26', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=1889ea26&scoped=true&", function () {
      api.rerender('1889ea26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/Panel.vue"
export default component.exports